<template>
   <div class="page">
     <template v-if="userInfo">
       <div class="userInfo" v-if="false">
          <div class="l">
            <div class="img"><img :src="userInfo.userHeadIcon" alt=""></div>
            <div class="infos">
              <div class="name">{{userInfo.userNickName}}</div>
              <div class="ids">ID:{{userInfo.accountId}}</div>
            </div>
          </div>
          <!-- <div id="downloadButton" class="r" v-if="isIOS"><img src="@/assets/images/h5/icon_topbtn_phone.png" alt="">前往APP</div>
          <div class="r" v-else><img src="@/assets/images/h5/icon_topbtn_phone.png" alt=""><a :href="downSrc">前往APP</a></div> -->

          <div class="r" v-if="!isYp"><img src="@/assets/images/h5/icon_topbtn_phone.png" alt="" >
          <wx-open-launch-app
            id="launch-btn"
            @error="handleError"
            @launch="handleLaunch"
            appid="wxf1788103e99208b8"
            extinfo=""
          >
            <script type="text/wxtag-template">
              <style>
                .btn {
                  height: 36px;
                  color:#fff;
                  background:none;
                  border:none;
                }
              </style>
              <button class="download btn" style="height: 36px;width:100%;border:none;">去往APP</button>
            </script>
          </wx-open-launch-app>
          </div>



        </div>

        <div class="list on">
          <div class="item" v-for="item of listData" :key="item.id" @click="toBuy(item)">
            <img :src="item.productPic" alt="">
            <div class="name">
              {{item.productName}}
            </div>
            <div class="price">前往充值<i class="iconfonts icon-next"></i></div>
          </div>
          <div class="item" v-for="item of list" :key="item.id" @click="toDetail(item)">
            <img :src="item.productPic" alt="">
            <div class="name">
              {{item.productName}}
              <div class="info" v-if="item.info">{{item.info}}</div>
            </div>
            <div class="price">￥<span>{{item.price}}</span></div>
          </div>
        </div>
     </template>
     <template v-else>
       <div class="noBox">
         <div class="logo"><img src="@/assets/images/h5/img_logo.png" alt=""></div>
         <div class="tit">您还未注册{{titles}}游戏哦~</div>
         <a :href="downSrc"><div class="downBtn"><img src="@/assets/images/h5/img_bntdownload.png" alt=""><span>点击下载</span><i>{{totalTime}}s</i></div></a>
       </div>
     </template>


     <van-popup v-model:show="show">
      <div class="pop-box">
				<div class="tit">购买成功!</div>
				<!-- <div class="tit">请前往闲逸查看</div> -->

				<div class="btns">
					<div class="btn" @click="closeFn">
						关闭
					</div>
					<!-- <div class="btn reapp" v-if="listData.length" id="downloadButton2">
						前往APP
					</div> -->
				</div>
			</div>
    </van-popup>



   </div>
</template>
<script>
import Vue from 'vue'
import config from '@/config/index'

export default {
  data () {
    return {
      token : '',
      isYp : config.isYp,
      titles : config.isYp ? '邀朋' : '闲逸',
      listData : [
        // {
        //   id : '1', productName : `${config.isYp ? '邀朋豆' : '闲逸豆'}`, price : '', productPic : require('@/assets/images/h5/img_01.png'),href : ''
        // },
        // {
        //   id : '2', productName : '鲨鱼来袭', price : '', productPic : require('@/assets/images/h5/img_04.png'),href : 'https://openapi-sdk.91xyqp.cn/game-sdk/public/app/188007'
         //},
        // {
         //  id : '3', productName : '决战沙邑', price : '', productPic : require('@/assets/images/h5/img_05.png'),href : 'https://openapi-sdk.91xyqp.cn/game-sdk/public/app/188006'
         //}
      ],
      list : [],
      payBtn : true,
      msg : '',
      show : false,
      loadBtn : false,
      isIOS : false,
      userInfo : null,
      totalTime : 5,
      downSrc : 'http://apk.91xyqp.cn/web-down/index.html',
    }
  },
  created () {
    const u = navigator.userAgent;
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    this.token = localStorage.getItem('token_key')


  },
  mounted () {
    this.wxReadyInit()

    this.getUserInfo()
    // if(this.isIOS){
    //   const s = document.createElement('script');
    //   s.type = 'text/javascript';
    //   s.src = '//web.cdn.openinstall.io/openinstall.js' ;
    //   s.addEventListener('load',()=>{
    //     var data = OpenInstall.parseUrlParams();
    //     new OpenInstall({
    //     appKey : "j7avzo",
    //     preferWakeup:true,
    //     onready : function() {
    //       var m = this,
    //       button = document.getElementById("downloadButton")||null;
    //       m.schemeWakeup();
    //       if(button){
    //         button.onclick = function() {
    //                 m.wakeupOrInstall();
    //                 return false;
    //         }
    //       }
    //       }
    //     },data);

    //   },false)

    //   document.head.appendChild(s);
    // }

  },
  components: {

  },
  methods: {
    toBuy(item){
      if(item.href){
        window.location.href= item.href;
      }else{
        this.$router.push({
          path: '/buy',
          query: {}
        })
      }

    },
    toDetail(item){
      console.log(item)
      let {id=''} = item;
      this.$router.push({
        path: '/detail',
        query: {
          id
        }
      })
    },
    countDown () {
        let clock = window.setInterval(() => {
          this.totalTime--
          if (this.totalTime <= 0) {
            window.clearInterval(clock);
            window.location.href= this.downSrc;
          }
        },1000)
    },
    async pays(item){
        console.log(item)

				if(this.payBtn){
					this.payBtn = false;
          let attach = item.attach || '';
          let appid = localStorage.getItem('appId')
					let d = {
						productId : item.id,
						openId : this.token,
            attach,
            appid
					}
					let res = await this.$api.user.orderCreate(d)

					if(res.data.code == 200){
            let payInfo = res.data.data;
            if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.wxPay(payInfo), false)
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.wxPay(payInfo))
                document.attachEvent('onWeixinJSBridgeReady', this.wxPay(payInfo))
              }
            } else {
              console.log('准备调用微信支付')
              this.wxPay(payInfo)
            }
					}else{
						this.$toast(res.data.message)
					}
          this.payBtn = true;

				}

		},
		wxPay(data){
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.appId, // 公众号名称，由商户传入
            'timeStamp': String(data.timeStamp), // 时间戳
            'nonceStr': data.nonceStr, // 随机串
            'package': data.packageValue, // 预支付id
            'signType': data.signType, // 微信签名方式
            'paySign': data.paySign // 微信签名
          },
           (res) => {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.openFn()
            } else {
              this.$toast('下单失败')
            }
            this.$toast.clear()
          }
        )
	  },
		async getUserInfo(){
				let res = await this.$api.user.getUserInfo({
					openId : this.token
				})
        if(res.code == 200){
          let data = res.data;
          this.userInfo = data;
          this.loadBtn = true;
          if(data && data.weekMonthProductList){
            this.list = data.weekMonthProductList;
          }


          // if(!data || !data.accountId){
          //   this.countDown()
          // }
        }else{
          this.$toast(res.message)
        }


		},
    closeFn(){
        this.show = false;
    },
    openFn(){
        this.show = true;
    },
    returnFn(){
        // var ifr = document.createElement('iframe');
        //   ifr.setAttribute('id', 'frm');
        // ifr.setAttribute('src',  'j7avzo://');
        // document.body.appendChild(ifr);
    },
    handleError(e) {
      console.log("error", e, e.detail);
      // 跳到下载download.html页面
      // Dialog.alert({ message: "error:" + JSON.stringify(e.detail) });
    },

    handleLaunch(e) {
      console.log("success", e, e.detail);
      // Dialog.alert({ message: "success:" + JSON.stringify(e) });
    },
    wxReadyInit () {
        let appId = localStorage.getItem('appId') || ''
        let Url = window.location.href.split('#')[0]
        this.$api.user.getTicket({ url: encodeURIComponent(Url) }).then(data => {
          this.$wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ['onMenuShareAppMessage','wx-open-launch-app'], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-app'] // 需要使用的开放标签列表
          })
          this.$wx.error(function (res) {
            console.log('error')
            console.log(res)
          })
          this.$wx.ready(function (res) {
            console.log('ready')
            this.$wx.checkJsApi({
              jsApiList: ['wx-open-launch-app'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function (res) {
                console.log('可用')
              },
              fail: (err) => {
                console.log(err, '不可用')
              }
            })
          })
        })
    }

  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  padding: 16px;
  box-sizing: border-box;

}
.noBox{
  width: 100%;
  height: 265px;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  padding: 30px 12px;
  box-sizing: border-box;
  .logo{
    width: 80px;
    height: 80px;
    margin: 0 auto 30px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .tit{
    text-align: center;
    font-size: 15px;
    color: #333;
    margin-bottom: 40px;
  }
  a{
    color: #fff;
  }
  .downBtn{
    width: 100%;
    height: 40px;
    background: #07C160;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    border-radius: 4px;
    img{
      width: 22px;
      height: 22px;
    }
    span{
      margin: 0 5px;
    }
    i{
      opacity: 0.6;
      font-style: normal;
    }
  }
}
 .list{
		width: 100%;
    // padding-top: 64px;
    .item{
      width: 100%;
      height: 80px;
      padding: 8px;
      box-sizing: border-box;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 4px;
      img{
        width: 50px;
        height: 50px;
        border-radius: 6px;
      }
      .name{
        width: 160px;
        padding-left: 20px;
        font-size: 16px;
        color: #333;
      }
      .info{
        font-size: 16px;
        color: #F58C5D;
        padding-top: 2px;
      }
      .price{
        width: 80px;
        height: 32px;
        border-radius: 16px;
        border: 1px solid #F58C5D;
        text-align: center;
        font-size: 12px;
        color: #F58C5D;
        display: flex;
        justify-content: center;
        align-items: center;
        span{
          font-size: 16px;
        }
      }
    }
	}

  .userInfo{
    width: 100%;
    height: 48px;
    padding: 0  6px;
    box-sizing: border-box;
    background: #2E3D54;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    position: fixed;
    left:0;
    top: 0;
    z-index: 9;
    .l{
      width: 200px;
      display: flex;
      align-items: center;
      img{
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }
    }
    .r{
      width: 100px;
      height: 36px;
      border-radius: 18px;
      background: linear-gradient(223deg, #30DF93 0%, #3CD6B7 100%);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 14px;
      img{
        width: 16px;
        height: 16px;
      }
      a{color: #fff;}
    }
    .infos{
      padding-left: 10px;
      font-size: 14px;
    }

  }


  .pop-box{
		width: 240px;
		background: #fff;
		border-radius: 10px;
		padding: 12px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.tit{
			font-size: 15px;
			color: #FE860C;
			line-height: 25px;
		}
		.btns{
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: 15px;
			.btn{
				width: 90px;
				height: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: linear-gradient(126deg, #FE860C 0%, #FC5F2C 100%);
				border-radius: 15px;
				font-size: 14px;
				color: #fff;
				position: relative;

				&.reapp{
					margin-left: 10px;
				}
				button{
					width: 100%;
					height: 100%;
					background: none;
					border: none;
					position: absolute;
					left: 0;
					top: 0;
					&::after{
						border: none;
					}
				}
			}
		}
	}


  .return-top{
		width: 45px;
		height: 45px;
		overflow: hidden;
		position: fixed;
		right: 12px;
		bottom: 75px;
    background: url('https://xianyihuyu.oss-cn-shenzhen.aliyuncs.com/tool/xy_app_return.png') no-repeat;
    background-size: 100% 100%;
    a{
      display: block;
      width: 100%;
      height: 100%;
    }
		.item{
			width: 45px;
			height: 45px;
			margin-bottom: 10px;
			image{
				width: 100%;
				height: 100%;
			}
			button{
			  width: 100%;
			  height: 100%;
			  background: none;
			  border: none;
			  &::after{
			  	border: none;
			  }
			}
		}
	}

  .downBox{
    text-align: center;
    padding-top: 100px;
    .btn{
      width: 200px;
      height: 50px;
      line-height: 50px;
      border-radius: 25px;
      background: #FE630C;
      color: #fff;
      font-size: 18px;
      text-align: center;
      margin: 20px auto 0;
      a{
        color: #fff;
      }
    }
  }

</style>
